import classNames from 'classnames'

import './Form.scss'

interface FormBodyProps {
  className?: string
  children?: React.ReactNode
}

export const FormBody: React.FC<FormBodyProps> = ({ className, children }) => {
  return <div className={classNames('form-body', className)}>{children}</div>
}
